import { createFileRoute } from '@tanstack/react-router';
import TeamTab from '../../../components/account-management/settings/team-tab/TeamTab';
import Loader from '../../../components/shared/custom-components/Loader';

export const Route = createFileRoute('/_authenticated/settings/team')({
  pendingComponent: () => (
    <Loader marginTop={3} fillSpace LoaderContainerClasses={{}} />
  ),
  component: TeamTab,
});
